// import api from '../api-client';
import { ApiConstants } from "../utils/ApiConstants";
import axios from "axios";

export default class PaymentService {
  static getCaptureContext = (iFrameUrl: string) => {
    return axios.get(ApiConstants.captureContext, { params: { parentUrl: iFrameUrl } });
  };

  static getCaptureContextWithApp = (iFrameUrl: string, appName: string) => {
    return axios.get(ApiConstants.captureContext, { params: { parentUrl: iFrameUrl, appName: appName } });
  };

  static getCaptureContextWithCorsUrl = (iFrameUrl: string, corsUrls: string) => {
    return axios.get(ApiConstants.captureContext, { params: { parentUrl: iFrameUrl, corsUrls: corsUrls } });
  };

  static getPermanentToken = (tempToken: string) => {
    return axios.post(ApiConstants.permToken, { tempToken });
  };

  static getDecryptRequest = async (appName: string, encryptedRequestKey: string, encryptedRequest: string) => {
    return await axios.post(ApiConstants.decryptRequest, {
      encryptedRequest,
      encryptedRequestKey,
      appName,
    });
  };

  static getEncryptResponse = async (appName: string, response: string) => {
    return await axios.post(ApiConstants.encryptResponse, {
      response,
      appName,
    });
  };

  static submitCusasm = (cusasm: any) => {
    return axios.post(ApiConstants.cusasm, cusasm);
  };

  static submitMycanoncpsap = (mycanoncps: any) => {
    return axios.post(ApiConstants.mycanoncpsap, mycanoncps);
  };

  static submitMycanon = (mycanon: any) => {
    return axios.post(ApiConstants.mycanon, mycanon);
  };

  static submitMycanoncpscc = (mycanoncps: any) => {
    return axios.post(ApiConstants.mycanoncpscc, mycanoncps);
  };

  static submitMycanonsnr = (mycanonsnr: any) => {
    return axios.post(ApiConstants.mycanonsnr, mycanonsnr);
  };

  static submitCusac360b2bcarepak = (cusac360b2bcarepak: any) => {
    return axios.post(ApiConstants.cusac360b2bcarepak, cusac360b2bcarepak);
  };

  static submitCusac360b2bsnr = (cusac360b2bsnr: any) => {
    return axios.post(ApiConstants.cusac360b2bsnr, cusac360b2bsnr);
  };

  static submitS21csamycsach = (s21csamycsach: any) => {
    return axios.post(ApiConstants.s21csamycsach, s21csamycsach);
  };
}
